import { render, staticRenderFns } from "./profile-applied-rules-review.vue?vue&type=template&id=209ee2a4"
import script from "./profile-applied-rules-review.vue?vue&type=script&lang=js"
export * from "./profile-applied-rules-review.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports